<script setup lang="ts">
import Button from "@/components/Button.vue";
import services from "@/services";
import { useToaster } from "ram-components";
import { ref } from "vue";
import { useRouter } from "vue-router";

const loading = ref(false);
const successMessage = ref("");
const errorMessage = ref("");
const invalid = ref(false);
const email = ref("");

const toaster = useToaster({
  position: "bottom-right",
  closeOnClick: false,
  pauseOnHover: true,
  showCloseOnHover: true,
  timeout: 6000,
});

const router = useRouter();

const submit = async (form: { email: string }) => {
  loading.value = true;
  errorMessage.value = "";
  successMessage.value = "";

  try {
    if (!form.email) {
      invalid.value = true;
      return;
    }
    const response = await services.saveTokenForgotPassord(form.email);

    const result = response.data.result;

    toaster.push({
      type: "success",
      text: result.message,
    });
    setTimeout(() => router.push("/login"), 1000);
  } catch (err: any) {
    toaster.push({
      type: "error",
      text: err.response?.data?.message,
    });
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <div
    class="relative flex min-h-screen items-center justify-center bg-gray-100 p-4"
  >
    <div class="absolute right-4 top-0 z-50">
      <img src="/src/assets/img/ram-logo.png" alt="Logo" class="h-14 w-auto" />
    </div>

    <div class="w-full max-w-md rounded-2xl bg-white p-8 shadow-lg">
      <div class="mb-4 flex justify-center">
        <img
          src="/src/assets/img/sb_logo.png"
          alt="SB Logo"
          class="h-16 w-auto"
        />
      </div>
      <h3 class="text-center font-semibold">SBSA Pick Up Point</h3>
      <h2 class="mb-6 mt-3 text-center text-2xl font-semibold text-gray-800">
        Forgot Password
      </h2>
      <FormKit
        type="form"
        submit-label="Send Reset Link"
        @submit="submit"
        :disabled="loading"
        :actions="false"
      >
        <FormKit
          type="email"
          name="email"
          v-model="email"
          label="Email Address"
          placeholder="Enter your email"
          required
          label-class="block text-sm font-medium text-gray-700 mb-1"
          input-class="w-full px-4 py-2.5 border border-gray-300 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-sbsa-blue focus:border-transparent"
        />

        <p v-if="successMessage" class="mt-3 text-sm text-green-600">
          {{ successMessage }}
        </p>

        <div class="mt-6">
          <Button
            type="submit"
            :disabled="!email"
            :loading="loading"
            variant="ram"
            class="w-full"
          >
            {{ loading ? "Sending Reset Link" : "Send Reset Link" }}
          </Button>
        </div>
      </FormKit>
    </div>
  </div>
</template>
